export default function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}


//////////////////
// WEBPACK FOOTER
// /Users/izizac/Desktop/Biurko — MacBook Pro (Maciej)/sage/node_modules/swiper/esm/components/core/transition/setTransition.js
// module id = 42
// module chunks = 0